import React, { useEffect, useState } from 'react'
import styles from './EstablishmentsPage.module.css'
import Navbar from '../../components/Navbar/Navbar'
import EventsList from '../../components/EventsList/EventsList'
import CustomButton from '../../components/UI/CustomButton/CustomButton'
import plusIcon from '../../assets/icons/plus.svg'
import { EventType } from '../MainPage/MainPage'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import Loader from '../../components/UI/Loader/Loader'
import { EstablishmentsType } from '../../redux/actions/types'
import { useLocation } from 'react-router-dom'
import { establishmentsPerPage } from '../../constants/constants'
import {
  getEstablishmentFromCompany,
  getEstablishments,
} from '../../redux/actions/establishmentsAction'
import FilterPanelEstablishment from '../../components/FilterPanelEstablishment/FilterPanelEstablishment'
import CustomModal from '../../components/UI/CustomModal/CustomModal'
import CreateEstablishmentModal from '../CreateEstablishmentModal/CreateEstablishmentModal'
import { useMediaQuery } from 'react-responsive'

const EstablishmentsPage = () => {
  const [currentPage, setCurrentPage] = useState(1)
  const [visibleModal, setVisibleModal] = useState(false)
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })
  const dispatch = useAppDispatch()
  const location = useLocation()

  const { isLoading, establishment } = useAppSelector((state) => state.establishments)
  const { token, userRole } = useAppSelector((state) => state.auth)

  const dummyData = (array: EstablishmentsType[]) => {
    const items: EventType[] = array.map((establishment) => {
      return {
        id: establishment.id,
        title: establishment?.name,
        subTitle: establishment.company?.name,
        numberOfPerson: String(establishment.size),
        images: establishment.images.map((p, index) => {
          return { id: index, src: `${process.env.REACT_APP_BASE_URL_IMAGES}${p}` }
        }),
      }
    })
    return items
  }

  const eventList = dummyData(establishment?.establishments)

  const onRedirectToCreatePlatform = () => {
    setVisibleModal(true)
  }

  useEffect(() => {
    if (location.state) {
      dispatch(
        getEstablishments({
          token,
          page: currentPage,
          itemsPerPage: establishmentsPerPage,
          city: location.state.city,
          size: location.state.guestsNumber,
          name: location.state.name,
          address: location.state.address,
        }),
      )
    } else {
      if (
        userRole === 'directorPlace' ||
        userRole === 'employeePlace' ||
        userRole === 'employeeAgent' ||
        userRole === 'directorAgent'
      ) {
        dispatch(
          getEstablishmentFromCompany({
            token,
            page: 1,
            itemsPerPage: 1000,
          }),
        )
      } else {
        dispatch(
          getEstablishments({ token, page: currentPage, itemsPerPage: establishmentsPerPage }),
        )
      }
    }
  }, [dispatch, currentPage, setCurrentPage, establishmentsPerPage])

  return (
    <div className={styles.mainPage}>
      <Navbar isPlatforms></Navbar>

      <div className={styles.content}>
        <div className={styles.header}>
          <div>
            <h1 className={styles.title}>
              {location?.state?.titlePage ? location?.state?.titlePage : 'Управление площадками'}
            </h1>
            <p className={styles.description}>Все площадки</p>
          </div>
          {userRole !== 'employeeAgent' && userRole !== 'employeePlace' && (
            <CustomButton
              iconSrc={isMobile ? plusIcon : ''}
              className={styles.addSiteBtn}
              title={!isMobile ? 'Создать площадку' : ' '}
              type='button'
              onClick={onRedirectToCreatePlatform}
            />
          )}
        </div>
        {(userRole === 'superAdmin' || userRole === 'admin') && (
          <div className={styles.filterContainer}>
            <FilterPanelEstablishment currentPage={currentPage} />
          </div>
        )}
        {isLoading ? (
          <Loader />
        ) : eventList.length !== 0 ? (
          <EventsList
            eventList={eventList}
            pageSize={establishmentsPerPage}
            bookingData={location?.state ? location.state : null}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalCountPages={establishment.totalCount}
            forEstablishments
          />
        ) : (
          <div className={styles.emptyMessage}>По запросу ничего не найдено</div>
        )}
      </div>

      <CustomModal visible={visibleModal} setVisible={setVisibleModal}>
        <CreateEstablishmentModal setVisibleModal={setVisibleModal} />
      </CustomModal>
      {/* <Footer /> */}
    </div>
  )
}

export default EstablishmentsPage
